import * as SHA256 from 'crypto-js/sha256';
import * as EncBase64 from 'crypto-js/enc-base64';

export function generateCodeVerifier(length: number = 128): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._';
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, x => chars.charAt(x % chars.length)).join('');
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
  if (isSecureCryptoAvailable()) {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(digest));

    const base64url = hashArray.map(b => String.fromCharCode(b)).join('');
    const base64 = btoa(base64url);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } else {
    const hash = SHA256(verifier);
    const base64 = hash.toString(EncBase64);

    // Chuyển sang định dạng base64url theo chuẩn PKCE
    return base64
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }
}

export function isSecureCryptoAvailable(): boolean {
  return (
    typeof window !== 'undefined' &&
    !!window.crypto &&
    !!window.crypto.subtle
  );
}

/** Số thứ tự dòng trong bảng admin (1-based, hỗ trợ phân trang server-side). */
export function getAdminTableRowNumber(index: number, pageNumber = 0, pageSize = 20): number {
  return pageNumber * pageSize + index + 1;
}

export interface TextToken {
  isLink: boolean;
  text: string;
  href?: string;
}

export function parseTextWithLinks(value?: string): TextToken[] {
  if (!value) {
    return [];
  }
  const urlRegex = /(https?:\/\/[^\s,]+)/gi;
  const tokens: TextToken[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = urlRegex.exec(value)) !== null) {
    if (match.index > lastIndex) {
      tokens.push({
        isLink: false,
        text: value.substring(lastIndex, match.index),
      });
    }
    const url = match[0];
    tokens.push({
      isLink: true,
      text: url,
      href: url,
    });
    lastIndex = urlRegex.lastIndex;
  }

  if (lastIndex < value.length) {
    tokens.push({
      isLink: false,
      text: value.substring(lastIndex),
    });
  }

  return tokens;
}

